import React from 'react';
import { Link } from 'react-router-dom';
import { getReadinessFixGuide } from './readinessFixRoutes';

export function ReadinessFixGuide({ check, remediation }) {
  const guide = getReadinessFixGuide(check);
  if (!guide) return null;

  const playbookSteps = Array.isArray(remediation?.fix_steps) ? remediation.fix_steps : [];
  const instructions = guide.instructions?.length ? guide.instructions : playbookSteps;
  if (!instructions.length && !guide.to) return null;

  return (
    <div className="mt-2 p-2 border rounded bg-light">
      <div className="small fw-semibold mb-1">Where to fix</div>
      <div className="mb-2">
        <Link to={guide.to} className="btn btn-sm btn-outline-primary">
          Open {guide.label}
        </Link>
      </div>
      {instructions.length ? (
        <div className="small mb-0">
          <div className="fw-semibold">Steps</div>
          <ol className="mb-0 ps-3">
            {instructions.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>
      ) : null}
    </div>
  );
}
